import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllControlePragaDoenca } from '../service';

import {
  LIST_CONTROLE_PRAGA_DOENCA,
  LIST_CONTROLE_PRAGA_DOENCA_PENDING,
  LIST_CONTROLE_PRAGA_DOENCA_SUCCESS,
  LIST_CONTROLE_PRAGA_DOENCA_FAILURE
} from '../actionTypes';

function* sagaListAllControlePragaDoenca() {
  yield put({ type: LIST_CONTROLE_PRAGA_DOENCA_PENDING })

  try {
    const list = yield call(findAllControlePragaDoenca)
    yield put({ type: LIST_CONTROLE_PRAGA_DOENCA_SUCCESS, list: list })

  } catch (error) {

    yield put({ type: LIST_CONTROLE_PRAGA_DOENCA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllControlePragaDoenca() {
  yield takeLatest(LIST_CONTROLE_PRAGA_DOENCA, sagaListAllControlePragaDoenca)
}
